<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15gHY3y/tc-custom/9780062207340.jpg?1735039230250" alt="This image is the cover for the book Perilous Sea, The Elemental Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perilous Sea, The Elemental Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The Victorian YA fantasy saga continues in this sequel to <i>The Burning Sky</i> as teen mages continue the fight to take back the magical Realm.</b><br/><br/>After spending the summer away from each other, Titus and Iolanthe (still disguised as Archer Fairfax) are eager to return to Eton College to resume their training to fight the Bane. Although no longer bound to Titus by blood oath, Iolanthe is more committed than ever to fulfilling her destiny—especially with the agents of Atlantis quickly closing in.<br/><br/>Soon after arriving at school, though, Titus makes a shocking discovery, one that throws into question everything he believed about their mission. Faced with this revelation, Iolanthe struggles to come to terms with her new role, while Titus must choose between following his mother's prophecies—or forging a divergent path to an unknowable future.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sherry Thomas
      </h2>
      
      <p class="authorDescription body article"><P>Sherry Thomas is the author of <I>The Burning Sky</I> and <I>The Perilous Sea</I>, the first two books in the Elemental Trilogy. Sherry immigrated to the United States from China when she was thirteen and taught herself English in part by devouring science fiction and romance novels. She is the author of several acclaimed romance novels and is the recipient of two RITA Awards. Sherry lives with her family in Austin, Texas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0eabbb71